import MJSONScreenshot from '@admin/components/mjson_screenshot'
import PropTypes from 'prop-types'
import React from 'react'

const getScreenshot = (entity) => ({
  engine: 'mjson',
  entity: `truevail_email_campaign_variants/${entity.code}`,
  width: 100,
  height: 75,
  screenshoted_at: entity.screenshoted_at,
  placeholder: entity.status === 'pending'
})

const EmailCampaignToken = ({ email_campaign, show_provider }) => (
  <div className="campaign-token compact">
    <div className="campaign-token-preview">
      <div className="campaign-token-preview-inner">
        <MJSONScreenshot { ...getScreenshot(email_campaign.variants[0]) } />
      </div>
    </div>
    <div className="campaign-token-label">
      <div className="token-link">
        { email_campaign.title }        
      </div>
      { show_provider &&
        <>
          { email_campaign.agency ?
            <div className="token-stats">
              <span>Agency: { email_campaign.agency.title }</span>
            </div> :
            email_campaign.team?.id !== 41 ?
              <div className="token-stats">
                <span>Team: { email_campaign.team.title }</span>
              </div> :
              <div className="token-stats">
                <span>Provider: Truevail</span>
              </div>    
          }
        </>
      }
    </div>
  </div>
)

EmailCampaignToken.propTypes = {
  email_campaign: PropTypes.object,
  show_provider: PropTypes.bool
}

export default EmailCampaignToken
